/**
 * Backend rule attributes and types reference (promotion service).
 * Use these values in data.js _rulesStructure so IF/THEN rules evaluate correctly.
 *
 * Backend: promotion/models/PromotionRule.js (RULE_ATTRIBUTES),
 *          promotion/services/promotion/promotionEvaluationService.js (resolve*Attribute),
 *          promotion/common/index.js (legacy compilePromotion uses rules.ruleType, rules.ifRules, rules.thenRules).
 */

// Rule types supported by backend (legacy createPromotion compiles these)
export const BACKEND_RULE_TYPES = ["cart", "product", "user"];

// User attributes (resolveUserAttribute) – use as rule.attributes in ifRules
export const USER_ATTRIBUTES = [
  "user_group",
  "total_spend",
  "total_spend_last_n_months",
  "purchase_count",
  "days_since_last_purchase",
  "abandoned_cart_days",
  "product_views",
  "marketing_campaign",
  "search_keywords",
  "brand_purchases",
  "first_purchase",
  "second_purchase",
  "third_purchase",
  "discount_used",
  "membership_months",
  "referral_count",
  "loyalty_tier",
  "product_reviews",
  "social_shares",
  "social_follow",
  "newsletter_subscriber",
  "age_range",
  "location",
  "product_interests",
  "birthday",
];

// Cart attributes (resolveCartAttribute)
export const CART_ATTRIBUTES = [
  "cart_total",
  "cart_count",
  "cart_categories",
  "cart_brands",
  "cart_weight",
  "shipping_method",
  "payment_method",
  "cart_discount_amount",
];

// Product attributes (resolveProductAttribute)
export const PRODUCT_ATTRIBUTES = [
  "product_id",
  "category_id",
  "brand_id",
  "product_price",
  "product_inventory",
  "product_margin",
  "product_tags",
  "product_rating",
  "product_new",
];

// Legacy compiler (common/index.js) expects each ifRule to have:
// - value (e.g. "spent_more_than"), operation (e.g. ">", "=="), attributes (e.g. "cart_total")
// - selectedValue (number or value), optional groupRule, optional listType "product"
// thenRule: value, selectedValue, listType "free_product", groupRule with attributes "upto_discount", value "on_cart_product"
export const LEGACY_IF_RULE_FIELDS = ["value", "operation", "attributes", "selectedValue", "groupRule", "listType", "logicalGroup"];
export const LEGACY_THEN_RULE_FIELDS = ["value", "selectedValue", "listType", "groupRule"];

/**
 * Map frontend attribute names (from data.js _rulesStructure) to backend attribute names.
 * Used by promotionRuleDefinitions.js so the same UI sends backend-ready payloads.
 * Backend resolveUserAttribute (promotionEvaluationService) supports all USER_ATTRIBUTES below.
 */
export const FRONTEND_TO_BACKEND_ATTRIBUTES = {
  // User (all user rules in data.js userActivity / loyaltyEngagement / demographicsPrefrences / specialOccasions)
  user_group_part: "user_group",
  purchased_n_times_till_date: "purchase_count",
  not_purchased_last_n_days: "days_since_last_purchase",
  has_abandoned_cart_last_n_days: "abandoned_cart_days",
  campaign_source: "marketing_campaign",
  has_searched_for_specific_keyword: "search_keywords",
  purchased_from_brand: "brand_purchases",
  used_discount_x: "discount_used",
  membership_duration_months: "membership_duration_months",
  review_count: "product_reviews",
  newsletter_subscribed: "newsletter_subscriber",
  specific_region_and_countries: "location",
  interested_brands_and_categories: "product_interests",
  upcoming_birthday: "birthday",
  // first_purchase, second_purchase, third_purchase, referral_count, loyalty_tier, age_range: same in backend, no mapping
  // Cart / product
  // items_count: "cart_count",
  each_or_any: "payment_method",
  product_has_not_been_pruchased_n_days: "days_since_last_purchase",
};
